import * as React from "react";
import HtmlQuestion from "./HtmlQuestion";
import SocialQuestion from "./SocialQuestion";
import TextQuestion from "./TextQuestion";
import EmailQuestion from "./EmailQuestion";
import StarRatingQuestion from "./StarRatingQuestion";
import NPSQuestion from "./NPSQuestion";
import TextAreaQuestion from "./TextAreaQuestion";
import RadioQuestion from "./RadioQuestion";
import DropDownQuestion from "./DropDownQuestion";
import MultiSelectQuestion from "./MultiSelectQuestion";
import LanguageQuestion from "./LanguageQuestion";
import CheckBoxQuestion from "./CheckBoxQuestion";
import SectionQuestion from "./SectionQuestion";
import ClickToCallQuestion from "./ClickToCallQuestion";
import { QuestionType } from "../../../types";
import VisitorNameQuestion from "./VisitorNameQuestion";
import VisitorPhoneQuestion from "./VisitorPhoneQuestion";
import isSectionVisible from "../helpers/isSectionVisible";


interface QuestionProps {
  question: any;
  answer: any;
  onChange: any;
  error: string;
  onChangeSection: any;
  visibleSections: any;
}

class Question extends React.Component<QuestionProps, {}> {
  renderQuestionType() {
    const question = this.props.question;
    const answer = this.props.answer;
    const onChange = this.props.onChange;
    const error = this.props.error;
    const onChangeSection = this.props.onChangeSection;

    const createInputElement = (component: any) => {
      return React.createElement(component, {
        question: question,
        answer: answer,
        onChange: onChange,
        error: error,
        onChangeSection: onChangeSection
      });
    };

    switch (question.QuestionType) {
      case QuestionType.HTML:
        return <HtmlQuestion question={question} />;
      case QuestionType.Text:
        return createInputElement(TextQuestion);
      case QuestionType.VisitorPhone:
        return createInputElement(VisitorPhoneQuestion);
      case QuestionType.Name:
        return createInputElement(VisitorNameQuestion);
      case QuestionType.Email:
        return createInputElement(EmailQuestion);
      case QuestionType.Radio:
      case QuestionType.GroupRadio:
        return createInputElement(RadioQuestion);
      case QuestionType.Checkbox:
        return createInputElement(CheckBoxQuestion);
      case QuestionType.Select:
      case QuestionType.Group:
        return createInputElement(DropDownQuestion);
      case QuestionType.TextArea:
        return createInputElement(TextAreaQuestion);
      case QuestionType.Language:
        return createInputElement(LanguageQuestion);
      case QuestionType.MultiSelect:
        return createInputElement(MultiSelectQuestion);
      case QuestionType.StarRating:
        return createInputElement(StarRatingQuestion);
      case QuestionType.NPS:
        return createInputElement(NPSQuestion);
      case QuestionType.Social:
        return createInputElement(SocialQuestion);
      case QuestionType.PageBreak:
        return null;
      case QuestionType.Section:
        return createInputElement(SectionQuestion);
      case QuestionType.ClickToCall:
        return createInputElement(ClickToCallQuestion);
      default:
        console.warn(
          "No component exists for QuestionType:",
          question.QuestionType
        );
        return null;
    }
  }

  render() {
    const component = this.renderQuestionType();
    if (
      !component ||
      isSectionVisible(
        this.props.question.SectionID,
        this.props.visibleSections
      ) === false
    ) {
      return null;
    }

    return <div className="velaro-form-group">{component}</div>;
  }
}

export default Question;
